import { render } from "./SentWhatsAppDialog.vue?vue&type=template&id=6ccd9064"
import script from "./SentWhatsAppDialog.vue?vue&type=script&lang=js"
export * from "./SentWhatsAppDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__